import {th} from 'date-fns/locale';
import { format,parse } from 'date-fns'

const BD_YEAR = 543;
const toDateThai = (dateString : string) => {
  if(!dateString) return null;

  const date = parse(dateString, 'yyyy-MM-dd', new Date());
  const dateFormatted = format(date, 'dd MMMM',{locale: th});
  const year = date.getFullYear() + BD_YEAR;

  return `${dateFormatted} ${year}`;
}
const getDate = (dateString : string) => {
  if(!dateString) return null;

  const date = parse(dateString, 'yyyy-MM-dd', new Date());
  const dateFormatted = format(date, 'dd',{locale: th});

  return `${dateFormatted}`;
}
const getMonth = (dateString : string) => {
  if(!dateString) return null;

  const date = parse(dateString, 'yyyy-MM-dd', new Date());
  const dateFormatted = format(date, 'MMMM',{locale: th});

  return `${dateFormatted}`;
}
const getYear = (dateString : string) => {
  if(!dateString) return null;

  const date = parse(dateString, 'yyyy-MM-dd', new Date());
  const year = date.getFullYear() + BD_YEAR;

  return `${year}`;
}
export default function useDateUtils(){
  return{
    toDateThai,
    getDate,
    getMonth,
    getYear
  }
}
